/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */

import { LogLevel } from '@framework/live2dcubismframework'

/**
 * Sample Appで使用する定数
 */

interface ILAppDefine {

  // Canvas width and height pixel values, or dynamic screen size ('auto').
  CanvasSize: { width: number, height: number } | 'auto'

  // 消息框
  MessageBoxId: string
  MessageStyle: Record<string, any>

  // 画面
  ViewScale : number
  ViewMaxScale : number
  ViewMinScale : number

  ViewLogicalLeft : number
  ViewLogicalRight : number
  ViewLogicalBottom : number
  ViewLogicalTop : number

  ViewLogicalMaxLeft : number
  ViewLogicalMaxRight : number
  ViewLogicalMaxBottom : number
  ViewLogicalMaxTop : number

  // 相対パス
  ResourcesPath: string

  BackImageName: string

  // 外部定義ファイル（json）と合わせる
  MotionGroupIdle: string // アイドリング

  MotionGroupTapBody: string // 体をタップしたとき

  // 外部定義ファイル（json）と合わせる
  HitAreaNameHead: string
  HitAreaNameBody: string

  // モーションの優先度定数
  PriorityNone: 0
  PriorityIdle: 1
  PriorityNormal: 2
  PriorityForce: 3

  // MOC3の一貫性検証オプション
  MOCConsistencyValidationEnable: boolean

  // デバッグ用ログの表示オプション
  DebugLogEnable: boolean
  DebugTouchLogEnable: boolean

  // Frameworkから出力するログのレベル設定
  CubismLoggingLevel: LogLevel

  // デフォルトのレンダーターゲットサイズ
  RenderTargetWidth: number
  RenderTargetHeight: number
}

// Canvas width and height pixel values, or dynamic screen size ('auto').
const config: ILAppDefine = {
  CanvasSize: 'auto',

  MessageBoxId: 'live2d-message-box',
  MessageStyle: {},

  // 画面
  ViewScale: 1.0,
  ViewMaxScale: 2.0,
  ViewMinScale: 0.8,

  ViewLogicalLeft: -1.0,
  ViewLogicalRight: 1.0,
  ViewLogicalBottom: -1.0,
  ViewLogicalTop: 1.0,

  ViewLogicalMaxLeft: -2.0,
  ViewLogicalMaxRight: 2.0,
  ViewLogicalMaxBottom: -2.0,
  ViewLogicalMaxTop: 2.0,

  // 相対パス
  ResourcesPath: '../../Resources/',

  BackImageName: '',

  // 外部定義ファイル（json）と合わせる
  MotionGroupIdle: 'Idle', // アイドリング
  MotionGroupTapBody: 'TapBody', // 体をタップしたとき

  // 外部定義ファイル（json）と合わせる
  HitAreaNameHead: 'Head',
  HitAreaNameBody: 'Body',

  // モーションの優先度定数
  PriorityNone: 0,
  PriorityIdle: 1,
  PriorityNormal: 2,
  PriorityForce: 3,

  // MOC3の一貫性検証オプション
  MOCConsistencyValidationEnable: true,

  // デバッグ用ログの表示オプション
  DebugLogEnable: true,
  DebugTouchLogEnable: false,

  // Frameworkから出力するログのレベル設定
  CubismLoggingLevel: LogLevel.LogLevel_Verbose,

  // デフォルトのレンダーターゲットサイズ
  RenderTargetWidth: 1900,
  RenderTargetHeight: 1000,
}

export default config